/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DateFilterDto } from "./DateFilterDto.ts"

export const findIngestionsFiltersDtoStatusEnum = {
  PENDING: "PENDING",
  ERROR: "ERROR",
  FAILED: "FAILED",
  SUCCESS: "SUCCESS",
} as const

export type FindIngestionsFiltersDtoStatusEnumKey =
  (typeof findIngestionsFiltersDtoStatusEnum)[keyof typeof findIngestionsFiltersDtoStatusEnum]

export const findIngestionsFiltersDtoTypeEnum = {
  PRODUCT: "PRODUCT",
  BUSINESS_PARTNER: "BUSINESS_PARTNER",
  ECO_MODULATION: "ECO_MODULATION",
} as const

export type FindIngestionsFiltersDtoTypeEnumKey =
  (typeof findIngestionsFiltersDtoTypeEnum)[keyof typeof findIngestionsFiltersDtoTypeEnum]

export type FindIngestionsFiltersDto = {
  /**
   * @type array | undefined
   */
  status?: FindIngestionsFiltersDtoStatusEnumKey[]
  /**
   * @type array | undefined
   */
  userEmail?: string[]
  /**
   * @type object | undefined
   */
  createdAt?: DateFilterDto
  /**
   * @type array | undefined
   */
  fileName?: string[]
  /**
   * @type array | undefined
   */
  type?: FindIngestionsFiltersDtoTypeEnumKey[]
}
